import styled, { CSSProperties } from 'styled-components';

const Root = styled.div`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spaces.xxl};
  background: ${({ theme }) => theme.backgroundColors.white};
  box-shadow: ${({ theme }) => theme.boxShadow.base};
`;

const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`;

const Item = styled.li`
  margin: 0;
  padding: ${({ theme }) => theme.spaces.xl};
  cursor: pointer;

  &:hover {
    box-shadow: inset 0 -2px 0 ${({ theme }) => theme.borderColors.primary};
  }

  ${({ theme }) =>
    theme.screen.sp({
      fontSize: theme.fontSizes.xs,
      padding: `${theme.spaces.xl} ${theme.spaces.m}`,
    })}
`;

export const Nav = Object.assign(Root, {
  List,
  Item,
});
